module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_003.fcdca706.mp3";